import React from 'react';
import { useMediaQuery } from '@mui/material';

export default function useSidebar({ name = 'openSidebar', visible = false }: { name?: string; visible?: boolean }) {
	const isDesktop = useMediaQuery(theme => theme.breakpoints.up('xl'));

	const [sidebarOpen, setSidebarOpen] = React.useState(visible && isDesktop);
	const toggleSidebar = React.useCallback(() => setSidebarOpen(state => !state), [setSidebarOpen]);

	React.useEffect(() => {
		// if (visible && !isDesktop) setSidebarOpen(false);
		if (visible) setSidebarOpen(isDesktop);
	}, [isDesktop, visible]);

	return {
		sidebarOpen,
		setSidebarOpen,
		toggleSidebar
	};
}
